"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Offerwall = void 0;
var util_1 = require("@app/util");
var Offerwall = /** @class */ (function () {
    function Offerwall(loc, linksSelector, session) {
        this.loc = loc;
        this.linksSelector = linksSelector;
        this.session = session;
        this.clicksEvents = [];
    }
    // replace placeholders
    Offerwall.prototype.trackLinks = function () {
        var PP_WEBID = 'webid'; // webmasters id from partners network
        var params = __assign({ loc: this.loc, shortId: this.session.getShortId() }, this.session.getUtm());
        params[PP_WEBID] = this.session.getParntersWebId();
        var trackLinks = document.querySelectorAll(this.linksSelector + '[href]');
        trackLinks.forEach(function (a) {
            a.href = (0, util_1.replaceUrlPlaceholders)(a.href, params);
        });
    };
    Offerwall.prototype.addClickEvent = function (callback) {
        this.clicksEvents.push(callback);
    };
    Offerwall.prototype.trackClicks = function () {
        var self = this;
        document.querySelectorAll(this.linksSelector + '[href]').forEach(function (a) {
            a.addEventListener('click', function (e) {
                self.clicksEvents.forEach(function (cb) {
                    try {
                        cb(a);
                    }
                    catch (e) {
                        console.warn('callback click error', e);
                    }
                });
                // e.preventDefault();
                // setTimeout(() => {
                //   window.location.href = a.href;
                // }, 3000);
                // return false;
            });
        });
    };
    return Offerwall;
}());
exports.Offerwall = Offerwall;
